import { SignIn, useAuth } from "@clerk/remix";
import { useSearchParams } from "@remix-run/react";
import { useEffect, useState } from "react";
import { logger } from "~/logger";

export default function SignInPage() {
  const { isSignedIn, signOut } = useAuth();
  const [signOutCompleted, setSignOutCompleted] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirectTo");

  useEffect(() => {
    logger.info({ isSignedIn, signOutCompleted }, "SignInPage: signOut effect");

    // if they're signed in with the old session, sign them out
    if (isSignedIn && !signOutCompleted) {
      logger.info({}, "SignInPage: signing out user");
      signOut()
        .then(() => {
          logger.info({}, "SignInPage: sign out complete");
          setSignOutCompleted(true);
        })
        .catch(logger.error);
    }
  }, [isSignedIn, signOutCompleted, signOut]);

  return (
    <div className="flex h-full items-center justify-center bg-gradient-to-t bg-zinc-50 from-zinc-200 to-zinc-50 font-sans">
      {isSignedIn && !signOutCompleted ? (
        <div className="text-sm text-zinc-500">Signing out...</div>
      ) : (
        <SignIn
          routing={"path"}
          path={"/sign-in"}
          fallbackRedirectUrl={redirectTo || "/signed-in"}
          signUpFallbackRedirectUrl={redirectTo || "/signed-in"}
          signUpUrl="/sign-up"
          appearance={{
            elements: {
              rootBox: "shadow-none font-mona text-zinc-700",
              cardBox: "shadow-md bg-white rounded-md",
              header: "",
              headerTitle:
                "font-mona font-medium text-base text-left text-zinc-700",
              headerSubtitle: "text-sm text-left text-zinc-500",
              headerBackRow: "mb-0",
              logoBox: "h-8 flex flex-col items-start",
              logoImage: "h-8",
              socialButtonsIconButton:
                "border-transparent bg-zinc-50 grayscale rounded-sm hover:border-brand-800 hover:grayscale-0 hover:bg-white",
              formHeader: "px-6 py-3 bg-zinc-100 rounded-sm",
              formHeaderTitle: "text-zinc-700",
              formHeaderSubtitle: "text-zinc-500 font-sans",
              formButtonPrimary:
                " bg-brand-700  text-zinc-100 rounded-sm py-3 tracking-label normal-case text-sm font-normal border-solid border border-transparent after:!shadow-none !shadow-none hover:text-white hover:bg-brand-500 hover:border-brand-500",
              formFieldLabel: "font-mona font-normal text-zinc-600",
              formFieldInput:
                "leading-6 text-zinc-700 text-base rounded-sm shadow-sm",
              formResendCodeLink: "text-brand-800 tracking-tight",
              formFieldAction: "font-mona font-normal underline text-brand-800",
              footerActionLink:
                "font-mona font-normal underline text-brand-800",
              dividerLine: "bg-zinc-200",
              dividerText: "text-zinc-400 font-normal",
              identityPreview: "rounded-full pl-2",
              identityPreviewAvatarBox: " w-8 h-8",
              identityPreviewText: "text-zinc-700",
              identityPreviewEditButtonIcon: "w-4 text-zinc-500",
              alternativeMethodsBlockButtonText: "tracking-label",
            },
          }}
        />
      )}
    </div>
  );
}
